import { HudIconProps } from '../Icons/HudIcons';


export const thirdPartyModulesConfig: { [key: string]: { icon: HudIconProps['icon']; display: string; }; } = {
  pg: {
    icon: 'thirdParty.postgres',
    display: 'PostgreSQL'
  },
  axios: {
    icon: 'thirdParty.axios',
    display: 'Axios'
  },
  typeorm: {
    icon: 'thirdParty.typeorm',
    display: 'TypeORM'
  },
  dynamodb: {
    icon: 'thirdParty.dynamoDB',
    display: 'DynamoDB'
  }
};
